module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lara Casey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Lara Casey is a mom to three (one through the gift of adoption), a grateful wife, and a believer in the impossible. She created the PowerSheets grace-filled goal setting planner and the Write the Word journals, and she founded "), _c('I', [_vm._v("Southern Weddings")]), _vm._v(" Magazine a decade ago. Lara is also the author of "), _c('I', [_vm._v("Make It Happen: Surrender Your Fear. Take the Leap. Live On Purpose")]), _vm._v(". She lives in Chapel Hill, NC, and loves getting her hands dirty in the garden.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T8pqnS/tc-custom/9780718022396.jpg?1721404630220",
      "alt": "This image is the cover for the book Make it Happen"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Make it Happen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("You were created for a purpose, and it's time to make it happen.")]), _c('b', [_c('br')]), _c('i', [_vm._v("Make It Happen ")]), _vm._v("is the story of how I surrendered my fear, took the leap, and got a life. In my case, a perfectly imperfect, fulfilling life as a mama, a working woman, and a grateful wife. This is the story of how I chose to make \"it\"—a greater purpose than mine—happen, and how you can too."), _c('br'), _c('i', [_vm._v("Make It Happen")]), _vm._v(" is forwomen who find themselves worried, anxious, and completely overwhelmed by the constant chase for perfectionthose seeking the courage to jump into a new ventureworking women who are struggling to \"do it all\"weary wives and moms looking for relief from burning the candle at both endsanyone who dreams of a life lived not by accident, but on purposeYour time has come to take a leap of faith. Join me as we surrender our fears, end the chase for perfection, and say yes to cultivating the meaningful lives God desires for us."), _c('br'), _c('i', [_vm._v("You know all those things you've always wanted to do?")]), _c('i', [_vm._v("You should go do them.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0